import { useEditSpaceGroupMutation } from "@circle-react/components/SpaceGroups/EditFormV2/hooks/useEditSpaceGroupMutation";
import type { EditSpaceGroupFormValues } from "@circle-react/components/SpaceGroups/EditFormV3/types";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { useSpaceGroupResource } from "@circle-react/contexts/useSpaceGroupResource";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import type { SpaceGroup } from "@circle-react/types/SpaceGroup";

interface UseEditSpaceGroupModalParams {
  onClose: () => void;
  spaceGroup: SpaceGroup;
}

export const useEditSpaceGroupModal = ({
  spaceGroup: initialSpaceGroup,
  onClose,
}: UseEditSpaceGroupModalParams) => {
  const [shouldShowConfirmDeleteModal, toggleShouldShowConfirmDeleteModal] =
    useBoolean(false);
  const {
    data: spaceGroupDetails = {},
    isLoading: isLoadingSpaceGroupResource,
  } = useSpaceGroupResource(initialSpaceGroup?.id);
  const spaceGroupContext = useSpaceGroupsContext();

  const spaceGroup = { ...initialSpaceGroup, ...spaceGroupDetails };
  const activeSpaceGroupMembersCount = spaceGroup?.active_members_count;

  const { mutateAsync: editSpaceGroupMutationAsync, isPending: isEditing } =
    useEditSpaceGroupMutation({
      spaceGroup,
      onSuccess: onClose,
    });

  const onSubmit = async (data: EditSpaceGroupFormValues) => {
    await editSpaceGroupMutationAsync(data);
    spaceGroupContext?.actions?.refresh?.();
  };

  return {
    activeSpaceGroupMembersCount,
    isEditing,
    isLoadingSpaceGroupResource,
    onClose,
    onSubmit,
    shouldShowConfirmDeleteModal,
    spaceGroup,
    toggleShouldShowConfirmDeleteModal,
  };
};
